import React from 'react';
import styled from 'styled-components';
import { PODCAST_SAP_DESC, PODCAST_SAP_GEN } from 'Utils/Constants';
import {
  greyColor, loaderMergeGroup, primaryColor, primaryFont, primaryHeadingColor,
  SecondaryColor, secondaryFont, wMBold, wMedium,
} from 'Utils/utilsStyle';
import { useDispatch } from 'react-redux';
import { actions } from 'Slice/CompaniesSlice';
import classNames from 'classnames';
import PodcastSAP from '../svgIcons/PodcastSAP';

const StyleWrapper = styled.div`
&.empty {
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 5px;
  .text-div {
    align-items: center;
    .podcast-paragraph {
      text-align: center;
    }
  }
}
  display: flex;
  align-items: center;
  padding: 16px;
  column-gap: 5px;
  .loading-merge {
    width: 62px;
    height: 62px;
    flex-shrink: 0;
  }
  .text-div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    row-gap: 4px;
    .podcast-heading {
      a {
        color: ${primaryColor};
        text-decoration: underline;
      }
      display: inline-flex;
      color: ${primaryHeadingColor};
      font-family: ${secondaryFont};
      font-size: 16px;
      font-weight: ${wMBold};
      line-height: 20px;
      letter-spacing: -0.515px;
      margin: 0px;
      &.secondary {
        margin-left: 5px;
        color: ${SecondaryColor};
        margin: 0px 0px 0 7px;
      }
      &.refresh{
        display: initial;
      }
    }
    .podcast-paragraph {
      a {
        color: ${primaryColor};
        text-decoration: underline;
      }
      color: ${greyColor};
      font-family: ${primaryFont};
      font-size: 12px;
      font-weight: ${wMedium};
      line-height: 14px;
      letter-spacing: -0.362px;
      margin: 0;
    }
  }
  
`;

type Props = {
  type?: 'creating' | 'refresh' | 'empty'
  onRefresh: () => void
} & typeof defaultProps;

const defaultProps = {
  type: 'empty',
};
const PodcastCreatingScreen = function PodcastCreatingScreen(props: Props) {
  const { type, onRefresh } = props;
  const dispatch = useDispatch();
  const onChooseClick = () => {
    dispatch(actions.setShowSAPHistory(true));
    dispatch(actions.setShowCreateNew(false));
    dispatch(actions.setShowPodcastTab(false));
  };

  return (
    <StyleWrapper
      className={classNames({ empty: type === 'empty' })}
    >
      {type === 'creating' ? (
        <img className="loading-merge" src={loaderMergeGroup} alt="Loading..." />
      ) : (
        <PodcastSAP />
      )}
      <div className='text-div'>
        <h2 className={classNames('podcast-heading', { refresh: type === 'refresh' })}>
          {type === 'creating' ? 'Generating your' : type === 'empty' ? 'Create your' : null}
          {
            type === 'refresh'
              ? (
                <>
                  <a onClick={onRefresh}>Refresh</a>
                  {' '}
                  page to load
                  <br />
                  {' '}
                  your Podcast
                </>
              )
              : null
          }
          {type !== 'refresh' ? (
            <h2 className="podcast-heading secondary">
              Podcast
            </h2>
          ) : null}
        </h2>
        <p className="podcast-paragraph">
          {type === 'empty' ? (
            <>
              <a onClick={onChooseClick}>Choose</a>
              {' '}
              {PODCAST_SAP_DESC}
            </>
          ) : type === 'creating' ? PODCAST_SAP_GEN : null}
        </p>
      </div>

    </StyleWrapper>
  );
};
PodcastCreatingScreen.defaultProps = defaultProps;
export default PodcastCreatingScreen;
